import { graphql } from 'react-relay';

const homepageRootQuery = graphql`
    query homepageRootQuery(
        $isMobile: Boolean!
        $homepageId: String!
        $userId: String!
        $hasUserId: Boolean!
        $numPersonalizationItems: Int!
        $isTrade: Boolean!
    ) {
        viewer {
            ...HpRespLayout_viewer
            informationalContent @skip(if: $isTrade) {
                visible
            }
            homepage(rootId: $homepageId) {
                ...getHomePageMetaContent_homepage @relay(mask: false)
            }
        }
    }
`;

const homepageVariables = {
    isMobile: false,
    homepageId: '',
    userId: '',
    hasUserId: false,
    numPersonalizationItems: 0,
    isTrade: false,
};

export { homepageRootQuery, homepageVariables };
